import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import QuestionDatatable from "../../components/datatable/QuestionDatatable"
import { useState } from "react"

const QuestionList = () => {
    let [token] = useState(localStorage.getItem("token"));

    const redirectToLogin = () => {
        window.location.href = "/notFound";
    };

    return (
        <>
            {!token && redirectToLogin()}
            {token && (
                <div className="list">
                    <Sidebar />
                    <div className="listContainer">
                        <Navbar />
                        <QuestionDatatable />
                    </div>
                </div>
                )
            }
        </>
    )
}

export default QuestionList